var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('breadcrumbs',{attrs:{"home":_vm.name,"back":_vm.back}}),_c(_vm.report,{tag:"component",on:{"name":function($event){_vm.name = $event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }